import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { RootState } from '@/store'
import axios from 'axios'
import {
	KitRegistrationMeta,
	VerifyDateOfBirthParams,
	VerifyKitParams,
} from '@/modules/kitRegistrations/types/kitRegistrationTypes'

export type State = {
	meta: KitRegistrationMeta | null
}

export const state = (): State => ({
	meta: null,
})

const mutations: MutationTree<State> = {
	setKitRegistrationPageMeta(state: State, meta: KitRegistrationMeta) {
		state.meta = meta
	},
}

const actions: ActionTree<State, RootState> = {
	async verifyKit({ commit }, requestParams: VerifyKitParams) {
		await axios.post(
			`/restify/items/actions?action=validate`,
			{},
			{
				params: requestParams,
			},
		)
	},
	async verifyDateOfBirth({ commit, dispatch }, requestParams: VerifyDateOfBirthParams) {
		const { data } = await axios.post(
			`/kit-registrations/verify-client-dob/${requestParams.identifier}`,
			requestParams,
		)

		commit('auth/setUseOldAuthentication', true, { root: true })

		dispatch('auth/loginWithToken', { token: data.token, redirect: false }, { root: true })

		return data
	},
	async getKitRegistrationPageMeta({ commit, dispatch }, requestParams: {}) {
		const { meta } = await axios.get(`/restify/kit-registrations`, requestParams)
		commit('setKitRegistrationPageMeta', meta)
	},
	async validateOnSiteKit({ commit }, identifier: string) {
		const { data } = await axios.post(`/kit-registrations/on-site-kits/validate/${identifier}`)
		return data
	},
	async checkOnSiteKitEmail(
		{ commit },
		{ identifier, email }: { identifier: string; email: string },
	) {
		const { data } = await axios.post(`/kit-registrations/on-site-kits/check-email/${identifier}`, {
			email,
		})
		return data
	},
	async registerOnSiteKit({ commit }, identifier: string) {
		const { data } = await axios.post(
			`/kit-registrations/on-site-kits/register-existing/${identifier}`,
		)
		return data
	},
	async registerOnSiteKitNewUser(
		{ commit, dispatch },
		{
			identifier,
			email,
			first_name,
			last_name,
			dob,
		}: { identifier: string; email: string; first_name: string; last_name: string; dob: string },
	) {
		const { data } = await axios.post(
			`/kit-registrations/on-site-kits/register-new/${identifier}`,
			{
				email,
				first_name,
				last_name,
				dob,
			},
		)

		commit('auth/setUseOldAuthentication', true, { root: true })

		dispatch('auth/loginWithToken', { token: data.token, redirect: false }, { root: true })

		return data
	},
}

const getters: GetterTree<State, RootState> = {}

const module: Module<State, RootState> = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}

export default module
